import { VideoThumbnail } from "@/components/video";
import { cn } from "@/libraries/cn";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import IconButton from "@mui/material/IconButton";
import type React from "react";

interface GalleryImageProps {
	imgSrc: string;
	imgAlt: string;
	isActive: boolean;
	fileType?: File["type"];
	type?: "image" | "video";
	onViewImage: (e: React.MouseEvent<HTMLDivElement>) => void;
	onClickRemove: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const GalleryImage = (props: GalleryImageProps) => {
	const {
		imgSrc,
		imgAlt,
		type: mimeType = "image",
		isActive,
		fileType,
		onViewImage,
		onClickRemove,
	} = props;

	return (
		// biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
		<div
			className={cn(
				"relative aspect-[3/2] overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 ease-in-out",
				{
					"border-2 border-secondary": isActive,
				},
			)}
			onClick={onViewImage}
		>
			{mimeType.includes("image") ? (
				<img
					src={imgSrc}
					alt={imgAlt}
					loading="lazy"
					className="w-full h-full object-cover object-center"
				/>
			) : (
				<VideoThumbnail src={imgSrc} mimeType={fileType} className="h-full" />
			)}
			<IconButton
				color="inherit"
				size="small"
				className="!absolute top-0 right-0 z-10"
				onClick={onClickRemove}
			>
				<ClearOutlinedIcon fontSize="small" />
			</IconButton>
		</div>
	);
};

export default GalleryImage;
